import { AggregateFunction } from "../enum/aggregate-function";
import { DataType } from "../enum/data-type";

export class CardSettings {
  field!: string;
  dataType!: DataType;
  aggregateFunction!: AggregateFunction;
  mask?: string;
}